import { render, staticRenderFns } from "./InstructorApprovals.vue?vue&type=template&id=8c2f1b3a&"
import script from "./InstructorApprovals.vue?vue&type=script&lang=js&"
export * from "./InstructorApprovals.vue?vue&type=script&lang=js&"
import style0 from "./InstructorApprovals.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports